// extracted by mini-css-extract-plugin
export default {"root":"AdminAddPageTemplate_root__Shm73","buttons":"AdminAddPageTemplate_buttons__K63Ch"};